module.exports = __webpack_public_path__ + "img/p4.1e2fe4d6.jpg";